// src/pages/ActesPage.jsx
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import NouvelActeModal from '../components/actes/NouvelActeModal';
import ActeDetailModal from '../components/actes/ActeDetailModal';
import { 
  collection, 
  query, 
  where, 
  orderBy, 
  getDocs,
  doc,
  getDoc,
  Timestamp,
  limit,
  startAfter 
} from 'firebase/firestore';
import { db } from '../firebase/config';
import PageWrapper from '../layout/PageWrapper';
import { 
  Calendar, 
  List, 
  Plus, 
  Filter, 
  ChevronLeft, 
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Clock,
  User,
  Euro,
  AlertCircle,
  FileText,
  Search,
  MoreVertical,
  Edit,
  Trash2,
  Eye,
  X,
  Layers,
  Grid3x3,
  Check,
  Clock as ClockIcon,
  Loader2
} from 'lucide-react';
import { PiSyringeBold } from "react-icons/pi";

const ActesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  
  const [viewMode, setViewMode] = useState('agenda'); // 'agenda' ou 'list'
  const [agendaSubView, setAgendaSubView] = useState('detaillee'); // 'detaillee' ou 'globale'
  
  // États pour les données (SANS CACHE)
  const [actes, setActes] = useState([]);
  const [animaux, setAnimaux] = useState([]);
  const [intervenants, setIntervenants] = useState([]);
  const [typesActes, setTypesActes] = useState([]);
  const [typesActesMap, setTypesActesMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingActes, setLoadingActes] = useState(false); // Loading spécifique pour les actes
  
  // Pagination pour la vue liste
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalActes, setTotalActes] = useState(0);
  const [allActesForList, setAllActesForList] = useState([]); // Tous les actes filtrés pour la liste
  
  // Modal pour les actes groupés
  const [showGroupedActesModal, setShowGroupedActesModal] = useState(false);
  const [selectedGroupedActes, setSelectedGroupedActes] = useState([]);
  const [selectedGroupTitle, setSelectedGroupTitle] = useState('');
  
  // Filtres
  const [filters, setFilters] = useState({
    animal: '',
    typeActe: '',
    intervenant: '',
    statut: 'tous',
    recherche: ''
  });
  
  // Date pour la vue agenda
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  
  // Modal states
  const [showNewActe, setShowNewActe] = useState(false);
  const [showActeDetail, setShowActeDetail] = useState(false);
  const [selectedActe, setSelectedActe] = useState(null);

  const goToToday = () => {
    setCurrentMonth(new Date());
    setSelectedDate(new Date());
  };

  // Réinitialiser la pagination quand les filtres changent
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);
  useEffect(() => {
    loadReferenceData();
  }, []);

// Gestion des paramètres URL pour ouvrir automatiquement les modals



useEffect(() => {
  const acteId = searchParams.get('acteId');
  const animalId = searchParams.get('animalId');
  const openModal = searchParams.get('openModal');
  const groupedActesParam = searchParams.get('groupedActes');
  const typeParam = searchParams.get('type');
  
  console.log('🔄 useEffect déclenché avec:', { acteId, animalId, openModal, groupedActesParam, typeParam });
  
  // NOUVEAU BLOC : Gestion des actes groupés depuis le dashboard
  if (groupedActesParam) {
    console.log('📦 Chargement des actes groupés:', groupedActesParam);
    const acteIds = groupedActesParam.split(',');
    
    const loadGroupedActes = async () => {
      try {
        const actesPromises = acteIds.map(id => getDoc(doc(db, 'actes', id)));
        const actesDocs = await Promise.all(actesPromises);
        
        const groupedActes = [];
        actesDocs.forEach(doc => {
          if (doc.exists()) {
            groupedActes.push({ id: doc.id, ...doc.data() });
          }
        });
        
        console.log('✅ Actes groupés chargés:', groupedActes.length);
        
        if (groupedActes.length > 0) {
          setSelectedGroupedActes(groupedActes);
          setSelectedGroupTitle(typeParam || groupedActes[0].typeCategorie);
          setShowGroupedActesModal(true);
        }
      } catch (error) {
        console.error('❌ Erreur chargement actes groupés:', error);
      }
    };
    
    loadGroupedActes();
    return; // Sortir ici pour ne pas exécuter le reste
  }
  if (acteId) {
    console.log('🔍 Chargement de l\'acte:', acteId);





    


    // Charger l'acte depuis Firebase
    const loadActe = async () => {
      try {
        console.log('🔥 Appel Firebase pour acte:', acteId);
        const acteDoc = await getDoc(doc(db, 'actes', acteId));
        
        if (acteDoc.exists()) {
          const acteData = { id: acteDoc.id, ...acteDoc.data() };
          console.log('✅ Acte trouvé:', acteData);
          
          // Si l'acte a plusieurs animaux et qu'on veut ouvrir le modal groupé
          if (openModal === 'true' && acteData.animauxGroupes && acteData.animauxGroupes.length > 0) {
            console.log('📂 Ouverture modal groupé');
            const groupedActes = acteData.animauxGroupes.map(animalId => ({
              ...acteData,
              animalId: animalId
            }));
            setSelectedGroupedActes(groupedActes);
            setSelectedGroupTitle(acteData.typeCategorie || 'Acte groupé');
            setShowGroupedActesModal(true);
          } else {
            console.log('📂 Ouverture modal individuel');
            setSelectedActe(acteData);
            setShowActeDetail(true);
            console.log('✨ État showActeDetail mis à true');
          }
        } else {
          console.error('❌ Acte non trouvé dans Firebase');
        }
      } catch (error) {
        console.error('❌ Erreur Firebase:', error);
      }
    };
    
    loadActe();
  } else if (animalId && !showNewActe) {
    console.log('➕ Ouverture modal création avec animal:', animalId);
    setShowNewActe(true);
  } else {
    console.log('⚠️ Aucune action, pas d\'acteId ni animalId');
  }
}, [searchParams]);





// Nettoyer les paramètres URL après fermeture des modals
const handleCloseNewActe = () => {
  setShowNewActe(false);
  // Supprimer le paramètre animalId de l'URL
  if (searchParams.get('animalId')) {
    searchParams.delete('animalId');
    setSearchParams(searchParams);
  }
  handleDataUpdate();
};

const handleCloseActeDetail = () => {
  setShowActeDetail(false);
  setSelectedActe(null);
  // Supprimer le paramètre acteId de l'URL
  if (searchParams.get('acteId')) {
    searchParams.delete('acteId');
    setSearchParams(searchParams);
  }
};

  // Chargement des actes selon la vue
  useEffect(() => {
    if (viewMode === 'agenda') {
      loadActesForAgenda();
    } else {
      loadActesForList();
    }
  }, [filters, currentMonth, viewMode, currentPage, itemsPerPage]);

  // Charger les données de référence (animaux, intervenants, types)
  const loadReferenceData = async () => {
    try {
      // Charger les animaux
      const animauxSnap = await getDocs(collection(db, 'animaux'));
      const animauxData = animauxSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAnimaux(animauxData);

      // Charger les intervenants
      const intervenantsSnap = await getDocs(
        query(collection(db, 'intervenants'), where('actif', '==', true))
      );
      const intervenantsData = intervenantsSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setIntervenants(intervenantsData);

      // Charger les types d'actes
      const typesActesSnap = await getDocs(
        query(collection(db, 'typesActes'), where('actif', '==', true))
      );
      const typesActesData = typesActesSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTypesActes(typesActesData);
      
      // Créer une map pour accès rapide aux couleurs
      const typesMap = {};
      typesActesData.forEach(type => {
        const key = `${type.typeCategorie}-${type.nomActe}`;
        typesMap[key] = type;
      });
      setTypesActesMap(typesMap);
    } catch (error) {
      console.error('Erreur lors du chargement des données de référence:', error);
    }
  };

  // Charger les actes pour l'agenda (2 mois) - SANS CACHE
  const loadActesForAgenda = async () => {
    try {
      setLoadingActes(true);
      
      // Toujours charger le mois actuel et le suivant
      const nextMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1);
      
      // Calculer les dates de début et fin
      const startDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
      const endDate = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0);
      
      const startStr = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
      const endStr = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;
      
      // Construire la requête
      let acteQuery = collection(db, 'actes');
      const constraints = [];

      // Filtres
      if (filters.animal) {
        constraints.push(where('animalId', '==', filters.animal));
      }
      if (filters.typeActe) {
        constraints.push(where('typeCategorie', '==', filters.typeActe));
      }
      if (filters.intervenant) {
        constraints.push(where('intervenantId', '==', filters.intervenant));
      }
      if (filters.statut !== 'tous') {
        constraints.push(where('statut', '==', filters.statut));
      }

      if (constraints.length > 0) {
        acteQuery = query(acteQuery, ...constraints);
      }

      const actesSnap = await getDocs(acteQuery);
      let actesData = actesSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filtrer par date et statut côté client
      actesData = actesData.filter(acte => {
        // Filtrer par date (mois actuel + mois suivant)
        if (acte.dateActe < startStr || acte.dateActe > endStr) {
          return false;
        }
        // Filtrer les supprimés
        if (filters.statut !== 'supprime' && acte.statut === 'supprime') {
          return false;
        }
        // Filtrer par recherche
        if (filters.recherche) {
          const searchLower = filters.recherche.toLowerCase();
          return acte.nomActe?.toLowerCase().includes(searchLower) ||
                 acte.description?.toLowerCase().includes(searchLower) ||
                 acte.notes?.toLowerCase().includes(searchLower);
        }
        return true;
      });
      
      // Trier les actes
      actesData.sort((a, b) => {
        if (a.dateActe !== b.dateActe) {
          return a.dateActe.localeCompare(b.dateActe);
        }
        return (a.heureActe || '00:00').localeCompare(b.heureActe || '00:00');
      });
      
      setActes(actesData);
    } catch (error) {
      console.error('Erreur lors du chargement des actes:', error);
    } finally {
      setLoadingActes(false);
      setLoading(false);
    }
  };

  // Charger les actes pour la liste avec pagination
  const loadActesForList = async () => {
    try {
      setLoadingActes(true);
      
      // Construire la requête
      let acteQuery = collection(db, 'actes');
      const constraints = [];

      // Filtres
      if (filters.animal) {
        constraints.push(where('animalId', '==', filters.animal));
      }
      if (filters.typeActe) {
        constraints.push(where('typeCategorie', '==', filters.typeActe));
      }
      if (filters.intervenant) {
        constraints.push(where('intervenantId', '==', filters.intervenant));
      }
      if (filters.statut !== 'tous') {
        constraints.push(where('statut', '==', filters.statut));
      }

      // Ajouter orderBy pour le tri
      constraints.push(orderBy('dateActe', 'desc'));

      if (constraints.length > 0) {
        acteQuery = query(acteQuery, ...constraints);
      }

      const actesSnap = await getDocs(acteQuery);
      let actesData = actesSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filtrer côté client
      if (filters.statut !== 'supprime') {
        actesData = actesData.filter(acte => acte.statut !== 'supprime');
      }

      if (filters.recherche) {
        const searchLower = filters.recherche.toLowerCase();
        actesData = actesData.filter(acte => 
          acte.nomActe?.toLowerCase().includes(searchLower) ||
          acte.description?.toLowerCase().includes(searchLower) ||
          acte.notes?.toLowerCase().includes(searchLower)
        );
      }

      // Stocker tous les actes filtrés
      setAllActesForList(actesData);
      setTotalActes(actesData.length);

      // Paginer côté client
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedActes = actesData.slice(startIndex, endIndex);

      setActes(paginatedActes);
    } catch (error) {
      console.error('Erreur lors du chargement des actes:', error);
    } finally {
      setLoadingActes(false);
      setLoading(false);
    }
  };

  // Fonctions de navigation du calendrier
  const previousMonth = () => {
    const newMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1);
    setCurrentMonth(newMonth);
  };

  const nextMonth = () => {
    const newMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1);
    setCurrentMonth(newMonth);
  };

  // Chargement initial des données de référence
  const totalPages = Math.ceil(totalActes / itemsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const changeItemsPerPage = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Retour à la page 1
  };

  // Générer les numéros de page à afficher
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    const halfRange = Math.floor(maxPagesToShow / 2);
    
    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  // Générer les jours du mois pour l'agenda
  const getDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay() || 7; // Lundi = 1

    const days = [];
    
    // Jours du mois précédent
    for (let i = startingDayOfWeek - 1; i > 0; i--) {
      const date = new Date(year, month, 1 - i);
      days.push({ date, isCurrentMonth: false, actes: [] });
    }
    
    // Jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const dayActes = actes.filter(acte => acte.dateActe === dateStr);
      days.push({ date, isCurrentMonth: true, actes: dayActes });
    }
    
    // Compléter la dernière semaine
    const remainingDays = 42 - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      days.push({ date, isCurrentMonth: false, actes: [] });
    }
    
    return days;
  };

  const getStatutColor = (statut) => {
    switch (statut) {
      case 'realise': return 'bg-green-100 text-green-800 border-green-200';
      case 'planifie': return 'bg-gray-100 text-gray-800 border-gray-200';
      case 'annule': return 'bg-red-100 text-red-800 border-red-200';
      case 'reporte': return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'supprime': return 'bg-gray-100 text-gray-400 border-gray-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatutLabel = (statut) => {
    switch (statut) {
      case 'realise': return 'Réalisé';
      case 'planifie': return 'Planifié';
      case 'annule': return 'Annulé';
      case 'reporte': return 'Reporté';
      case 'supprime': return 'Supprimé';
      default: return statut;
    }
  };

  const handleActeClick = (acte) => {
    setSelectedActe(acte);
    setShowActeDetail(true);
  };

  // Fonction pour grouper les actes par type
  const groupActesByType = (dayActes) => {
    const grouped = {};
    
    dayActes.forEach(acte => {
      const type = acte.typeCategorie || 'Autre';
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push(acte);
    });
    
    return grouped;
  };

  // Ouvrir le modal des actes groupés
  const openGroupedActesModal = (actes, typeCategorie) => {
    setSelectedGroupedActes(actes);
    setSelectedGroupTitle(typeCategorie);
    setShowGroupedActesModal(true);
  };

  // Modal pour afficher les actes groupés
  const GroupedActesModal = () => {
    if (!showGroupedActesModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden">
          <div className="p-6 border-b flex items-center justify-between">
            <h3 className="text-lg font-semibold">
              {selectedGroupTitle} - {selectedGroupedActes.length} acte{selectedGroupedActes.length > 1 ? 's' : ''}
            </h3>
            <button
              onClick={() => setShowGroupedActesModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="p-6 overflow-y-auto max-h-[60vh]">
            <div className="space-y-3">
              {selectedGroupedActes.map(acte => {
                const animal = animaux.find(a => a.id === acte.animalId);
                const typeKey = `${acte.typeCategorie}-${acte.nomActe}`;
                const typeActe = typesActesMap[typeKey];
                const couleurActe = typeActe?.couleur || acte.couleur || '#6b7280';
                
                return (
                  <div
                    key={acte.id}
                    onClick={() => {
                      setShowGroupedActesModal(false);
                      handleActeClick(acte);
                    }}
                    className={`
                      p-4 rounded-lg border cursor-pointer hover:shadow-md transition-shadow
                      ${acte.statut === 'supprime' ? 'opacity-50' : ''}
                    `}
                    style={{
                      backgroundColor: acte.statut === 'supprime' ? '#f3f4f6' : couleurActe + '20',
                      borderColor: acte.statut === 'supprime' ? '#d1d5db' : couleurActe,
                      borderLeftWidth: '4px',
                      borderLeftColor: acte.statut === 'supprime' ? '#9ca3af' : couleurActe,
                      color: '#1f2937'
                    }}
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="font-semibold text-sm">
                          {acte.heureActe} - {animal?.nom}
                        </div>
                        <div className="text-sm mt-1">
                          {acte.typeCategorie} {acte.nomActe ? `- ${acte.nomActe}` : ''}
                        </div>
                        {acte.description && (
                          <div className="text-xs text-gray-600 mt-2">
                            {acte.description}
                          </div>
                        )}
                      </div>
                      <span className={`
                        inline-flex px-2 py-1 text-xs font-medium rounded-full
                        ${getStatutColor(acte.statut)}
                      `}>
                        {getStatutLabel(acte.statut)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Vue Agenda
  const AgendaView = () => {
    const days = getDaysInMonth();
    const weekDays = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
    
    return (
      <div className="bg-white rounded-lg border relative">
        {/* Indicateur de chargement */}
        {loadingActes && (
          <div className="absolute inset-0 bg-white bg-opacity-75 z-10 flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
          </div>
        )}
        
        {/* En-tête du calendrier */}
        <div className="p-4 border-b">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-4">
              <button
                onClick={previousMonth}
                className="p-2 hover:bg-gray-100 rounded-lg"
                disabled={loadingActes}
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <h2 className="text-lg font-semibold">
                {currentMonth.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
              </h2>
              <button
                onClick={nextMonth}
                className="p-2 hover:bg-gray-100 rounded-lg"
                disabled={loadingActes}
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
            <button
              onClick={goToToday}
              className="px-3 py-1 text-sm bg-black text-white rounded-lg hover:bg-gray-800"
              disabled={loadingActes}
            >
              Aujourd'hui
            </button>
          </div>
          
          {/* Sélecteur de sous-vue */}
          <div className="flex gap-2">
            <button
              onClick={() => setAgendaSubView('detaillee')}
              className={`
                px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2
                ${agendaSubView === 'detaillee' 
                  ? 'bg-gray-900 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
              `}
            >
              <Grid3x3 className="h-4 w-4" />
              Vue détaillée
            </button>
            <button
              onClick={() => setAgendaSubView('globale')}
              className={`
                px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2
                ${agendaSubView === 'globale' 
                  ? 'bg-gray-900 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
              `}
            >
              <Layers className="h-4 w-4" />
              Vue globale
            </button>
          </div>
        </div>

        {/* Jours de la semaine */}
        <div className="grid grid-cols-7 border-b">
          {weekDays.map(day => (
            <div key={day} className="p-2 text-center text-sm font-medium text-gray-700">
              {day}
            </div>
          ))}
        </div>

        {/* Grille du calendrier */}
        <div className="grid grid-cols-7">
          {days.map((day, index) => {
            const isToday = day.date.toDateString() === new Date().toDateString();
            const isSelected = selectedDate && day.date.toDateString() === selectedDate.toDateString();
            
            return (
              <div
                key={index}
                onClick={() => day.isCurrentMonth && setSelectedDate(day.date)}
                className={`
                  min-h-[120px] p-2 border-r border-b cursor-pointer hover:bg-gray-50
                  ${!day.isCurrentMonth ? 'bg-gray-50 text-gray-400' : ''}
                  ${isToday ? 'bg-gray-50' : ''}
                  ${isSelected ? 'ring-2 ring-black' : ''}
                `}
                style={{
                  minHeight: agendaSubView === 'detaillee' && day.actes.length > 3 
                    ? `${80 + (day.actes.length * 35)}px` 
                    : '120px'
                }}
              >
                <div className={`text-sm font-medium mb-1 ${isToday ? 'text-black font-bold' : ''}`}>
                  {day.date.getDate()}
                </div>
                
                {/* Vignettes des actes */}
                <div className="space-y-1">
                  {agendaSubView === 'detaillee' ? (
                    // Vue détaillée - TOUS les actes
                    <>
                      {day.actes.map(acte => {
                        const animal = animaux.find(a => a.id === acte.animalId);
                        const typeKey = `${acte.typeCategorie}-${acte.nomActe}`;
                        const typeActe = typesActesMap[typeKey];
                        const couleurActe = typeActe?.couleur || acte.couleur || '#6b7280';
                        
                        const bgColor = acte.statut === 'supprime' ? '#f3f4f6' : couleurActe + '20';
                        const borderColor = acte.statut === 'supprime' ? '#d1d5db' : couleurActe;
                        
                        return (
                          <div
                            key={acte.id}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleActeClick(acte);
                            }}
                            className={`
                              text-xs p-1 rounded border cursor-pointer hover:shadow-sm relative
                              ${acte.statut === 'supprime' ? 'opacity-50' : ''}
                            `}
                            style={{
                              backgroundColor: bgColor,
                              borderColor: borderColor,
                              borderLeftWidth: '3px',
                              borderLeftColor: acte.statut === 'supprime' ? '#9ca3af' : borderColor,
                              color: acte.statut === 'supprime' ? '#6b7280' : '#1f2937'
                            }}
                          >
                            {/* Icône de statut */}
                            <div className="absolute top-1 right-1">
                              {acte.statut === 'realise' && (
                                <Check className="h-3 w-3 text-green-600" />
                              )}
                              {acte.statut === 'planifie' && (
                                <ClockIcon className="h-3 w-3 text-gray-600" />
                              )}
                              {acte.statut === 'annule' && (
                                <X className="h-3 w-3 text-red-600" />
                              )}
                              {acte.statut === 'supprime' && (
                                <Trash2 className="h-3 w-3 text-gray-400" />
                              )}
                            </div>
                            <div className="font-medium truncate pr-4">
{acte.heureActe ? `${acte.heureActe} - ` : ''}{animal?.nom}
                            </div>
                            <div className="truncate opacity-75">
                              {acte.typeCategorie} {acte.nomActe ? `- ${acte.nomActe}` : ''}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    // Vue globale - grouper par type d'acte
                    <>
                      {Object.entries(groupActesByType(day.actes)).slice(0, 3).map(([type, groupedActes]) => {
                        const earliestTime = groupedActes.reduce((min, acte) => {
                          return acte.heureActe < min ? acte.heureActe : min;
                        }, groupedActes[0].heureActe);
                        
                        const hasDeleted = groupedActes.some(a => a.statut === 'supprime');
                        
                        let dominantColor = '#6b7280';
                        for (const acte of groupedActes) {
                          const typeKey = `${acte.typeCategorie}-${acte.nomActe}`;
                          const typeActe = typesActesMap[typeKey];
                          if (typeActe?.couleur) {
                            dominantColor = typeActe.couleur;
                            break;
                          } else if (acte.couleur) {
                            dominantColor = acte.couleur;
                            break;
                          }
                        }
                        
                        return (
                          <div
                            key={type}
                            onClick={(e) => {
                              e.stopPropagation();
                              openGroupedActesModal(groupedActes, type);
                            }}
                            className={`
                              text-xs p-1 rounded border cursor-pointer hover:shadow-sm
                              ${hasDeleted ? 'opacity-75' : ''}
                            `}
                            style={{
                              backgroundColor: hasDeleted ? '#f3f4f6' : dominantColor + '20',
                              borderColor: hasDeleted ? '#d1d5db' : dominantColor,
                              borderLeftWidth: '3px',
                              borderLeftColor: hasDeleted ? '#9ca3af' : dominantColor,
                              color: '#1f2937'
                            }}
                          >
                            <div className="font-medium truncate">
                              {earliestTime} - {groupedActes.length} {groupedActes.length > 1 ? 'chevaux' : 'cheval'}
                            </div>
                            <div className="truncate opacity-75">
                              {type}
                            </div>
                          </div>
                        );
                      })}
                      {Object.keys(groupActesByType(day.actes)).length > 3 && (
                        <div className="text-xs text-gray-500 text-center">
                          +{Object.keys(groupActesByType(day.actes)).length - 3} autres types
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Vue Liste avec pagination
  const ListView = () => {
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(currentPage * itemsPerPage, totalActes);
    
    return (
      <div className="space-y-4">
        {/* Contrôles de pagination en haut */}
        <div className="bg-white rounded-lg border p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-700">
                Afficher
              </span>
              <select
                value={itemsPerPage}
                onChange={(e) => changeItemsPerPage(Number(e.target.value))}
                className="px-3 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-700"
                disabled={loadingActes}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-sm text-gray-700">
                actes par page
              </span>
            </div>
            
            <div className="text-sm text-gray-700">
              {totalActes > 0 ? (
                <>
                  Actes {startIndex} à {endIndex} sur {totalActes}
                </>
              ) : (
                'Aucun acte'
              )}
            </div>
          </div>
        </div>
        
        {/* Tableau des actes */}
        <div className="bg-white rounded-lg border relative">
          {loadingActes && (
            <div className="absolute inset-0 bg-white bg-opacity-75 z-10 flex items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
            </div>
          )}
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Date/Heure
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Animal
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Type d'acte
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Intervenant
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Statut
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Coût
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {actes.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                      Aucun acte trouvé
                    </td>
                  </tr>
                ) : (
                  actes.map(acte => {
                    const animal = animaux.find(a => a.id === acte.animalId);
                    const intervenant = intervenants.find(i => i.id === acte.intervenantId);
                    
                    const typeKey = `${acte.typeCategorie}-${acte.nomActe}`;
                    const typeActe = typesActesMap[typeKey];
                    const couleurActe = typeActe?.couleur || acte.couleur || '#6b7280';
                    
                    return (
                      <tr
                        key={acte.id}
                        onClick={() => handleActeClick(acte)}
                        className={`hover:bg-gray-50 cursor-pointer ${acte.statut === 'supprime' ? 'opacity-50' : ''}`}
                      >
                        <td className="px-4 py-3">
                          <div className="text-sm font-medium text-gray-900">
                            {new Date(acte.dateActe).toLocaleDateString('fr-FR')}
                          </div>
{acte.heureActe && (
  <div className="text-xs text-gray-500">
    {acte.heureActe}
  </div>
)}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            {animal?.photoUrl && (
                              <img
                                src={animal.photoUrl}
                                alt={animal.nom}
                                className="h-8 w-8 rounded-full mr-2 object-cover"
                              />
                            )}
                            <div>
                              <div className="text-sm font-medium text-gray-900">
                                {animal?.nom}
                              </div>
                              <div className="text-xs text-gray-500">
                                {animal?.sire || '-'}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div 
                            className="inline-flex flex-col px-2 py-1 rounded-lg"
                            style={{
                              backgroundColor: acte.statut === 'supprime' ? '#f3f4f6' : couleurActe + '15',
                              borderLeft: `3px solid ${acte.statut === 'supprime' ? '#9ca3af' : couleurActe}`
                            }}
                          >
                            <div className="text-sm text-gray-900 font-medium">
                              {acte.nomActe}
                            </div>
                            <div className="text-xs text-gray-600">
                              {acte.typeCategorie}
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="text-sm text-gray-900">
                            {intervenant ? `${intervenant.prenom} ${intervenant.nom}` : '-'}
                          </div>
                          {intervenant && (
                            <div className="text-xs text-gray-500">
                              {intervenant.type}
                            </div>
                          )}
                        </td>
                        <td className="px-4 py-3">
                          <span className={`
                            inline-flex px-2 py-1 text-xs font-medium rounded-full
                            ${getStatutColor(acte.statut)}
                          `}>
                            {getStatutLabel(acte.statut)}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          {acte.cout ? (
                            <div className="text-sm font-medium text-gray-900">
                              {acte.cout.toFixed(2)} €
                            </div>
                          ) : (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
        
        {/* Contrôles de pagination en bas */}
        {totalPages > 1 && (
          <div className="bg-white rounded-lg border p-4">
            <div className="flex items-center justify-between">
              <div className="flex gap-2">
                <button
                  onClick={() => goToPage(1)}
                  disabled={currentPage === 1 || loadingActes}
                  className={`p-2 rounded-lg ${
                    currentPage === 1 || loadingActes
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'hover:bg-gray-100'
                  }`}
                  title="Première page"
                >
                  <ChevronsLeft className="h-4 w-4" />
                </button>
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1 || loadingActes}
                  className={`p-2 rounded-lg ${
                    currentPage === 1 || loadingActes
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'hover:bg-gray-100'
                  }`}
                  title="Page précédente"
                >
                  <ChevronLeft className="h-4 w-4" />
                </button>
              </div>
              
              <div className="flex gap-1">
                {currentPage > 3 && totalPages > 5 && (
                  <>
                    <button
                      onClick={() => goToPage(1)}
                      className="px-3 py-1 rounded-lg hover:bg-gray-100"
                      disabled={loadingActes}
                    >
                      1
                    </button>
                    <span className="px-2 py-1">...</span>
                  </>
                )}
                
                {getPageNumbers().map(page => (
                  <button
                    key={page}
                    onClick={() => goToPage(page)}
                    disabled={loadingActes}
                    className={`px-3 py-1 rounded-lg ${
                      page === currentPage
                        ? 'bg-black text-white'
                        : 'hover:bg-gray-100'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                
                {currentPage < totalPages - 2 && totalPages > 5 && (
                  <>
                    <span className="px-2 py-1">...</span>
                    <button
                      onClick={() => goToPage(totalPages)}
                      className="px-3 py-1 rounded-lg hover:bg-gray-100"
                      disabled={loadingActes}
                    >
                      {totalPages}
                    </button>
                  </>
                )}
              </div>
              
              <div className="flex gap-2">
                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages || loadingActes}
                  className={`p-2 rounded-lg ${
                    currentPage === totalPages || loadingActes
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'hover:bg-gray-100'
                  }`}
                  title="Page suivante"
                >
                  <ChevronRight className="h-4 w-4" />
                </button>
                <button
                  onClick={() => goToPage(totalPages)}
                  disabled={currentPage === totalPages || loadingActes}
                  className={`p-2 rounded-lg ${
                    currentPage === totalPages || loadingActes
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'hover:bg-gray-100'
                  }`}
                  title="Dernière page"
                >
                  <ChevronsRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Fonction pour recharger après création/modification
  const handleDataUpdate = () => {
    // Recharger les données
    if (viewMode === 'agenda') {
      loadActesForAgenda();
    } else {
      loadActesForList();
    }
  };

  return (
    <PageWrapper icon={PiSyringeBold} title="Actes" maxWidth="w-full">
      {/* Barre d'outils */}
      <div className="mb-6 flex flex-col sm:flex-row gap-4">
        {/* Boutons de vue */}
        <div className="flex gap-2">
          <button
            onClick={() => setViewMode('agenda')}
            className={`
              px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2
              ${viewMode === 'agenda' 
                ? 'bg-black text-white' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
            `}
          >
            <Calendar className="h-4 w-4" />
            Agenda
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`
              px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2
              ${viewMode === 'list' 
                ? 'bg-black text-white' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
            `}
          >
            <List className="h-4 w-4" />
            Liste
          </button>
        </div>

        <div className="flex-1" />

        {/* Filtres */}
        <div className="flex gap-2">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Rechercher..."
              value={filters.recherche}
              onChange={(e) => setFilters({ ...filters, recherche: e.target.value })}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-700"
            />
          </div>

          <select
            value={filters.animal}
            onChange={(e) => setFilters({ ...filters, animal: e.target.value })}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-700"
          >
            <option value="">Tous les animaux</option>
            {animaux.map(animal => (
              <option key={animal.id} value={animal.id}>
                {animal.nom}
              </option>
            ))}
          </select>

          <select
            value={filters.statut}
            onChange={(e) => setFilters({ ...filters, statut: e.target.value })}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-700"
          >
            <option value="tous">Tous les actes</option>
            <option value="planifie">Actes planifiés</option>
            <option value="realise">Actes réalisés</option>
            <option value="annule">Actes annulés</option>
            <option value="reporte">Actes reportés</option>
            <option value="supprime">Actes supprimés</option>
          </select>

          <button
            onClick={() => setShowNewActe(true)}
            className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 flex items-center gap-2"
          >
            <Plus className="h-4 w-4" />
            Nouvel acte
          </button>
        </div>
      </div>

      {/* Vue principale */}
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">Chargement...</div>
        </div>
      ) : (
        viewMode === 'agenda' ? <AgendaView /> : <ListView />
      )}

      {/* Modals */}
      
{showNewActe && (
  <NouvelActeModal
    isOpen={showNewActe}
    onClose={handleCloseNewActe}
    preselectedAnimalId={searchParams.get('animalId')}
  />
)}

      
{showActeDetail && selectedActe && (
  <ActeDetailModal
    isOpen={showActeDetail}
    onClose={handleCloseActeDetail}
    acteId={selectedActe.id}
    onUpdate={handleDataUpdate}
    onDelete={() => {
      handleDataUpdate();
      handleCloseActeDetail();
    }}
  />
)}
      
      {/* Modal des actes groupés */}
      <GroupedActesModal />
    </PageWrapper>
  );
};

export default ActesPage;